import { useCallback, useContext } from "react"
import {
  useNavigate as useRouterNavigate,
  type NavigateOptions,
  type To,
} from "react-router-dom"

import { AnimationRouterContext } from "@be-miniapp/ui/components/animated-context"

interface ExtendedNavigateOptions extends NavigateOptions {
  animate?: boolean
  direction?: "forward" | "backward"
}

type CustomNavigateFunction = (
  to: To | number,
  options?: ExtendedNavigateOptions
) => void

function useNavigate(): CustomNavigateFunction {
  const navigate = useRouterNavigate()
  const context = useContext(AnimationRouterContext)

  return useCallback<CustomNavigateFunction>(
    (to, options) => {
      const shouldAnimate = options?.animate ?? true
      let direction = options?.direction ?? "forward"

      if (typeof to === "number" && to < 0) {
        direction = "backward"
      }

      context?.prepareNavigation({ animate: shouldAnimate, direction })

      if (typeof to === "number") {
        context?.markPopstatePrepared()
        navigate(to)
      } else {
        navigate(to, options)
      }
    },
    [context, navigate]
  )
}

export { useNavigate }
export type { ExtendedNavigateOptions, CustomNavigateFunction }
